import React, { useState, useEffect, useMemo } from 'react';
import {
    Button,
    Typography,
    Table,
    TableBody,
    TableContainer,
    ButtonGroup
} from '@mui/material';
import DriveFolderUploadIcon from '@mui/icons-material/DriveFolderUpload';
import Input from '@mui/material/Input';
import { styled } from '@mui/material/styles';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import CardContent from '@mui/material/CardContent';
import Card from '@mui/material/Card';
import InputLabel from '@mui/material/InputLabel';
import Load from "../Load"
import DeleteIcon from '@mui/icons-material/Delete';
import VisibilityIcon from '@mui/icons-material/Visibility';
import Grid from '@mui/material/Grid';
import { useParams, useNavigate } from "react-router-dom"
import swal from 'sweetalert';
import { useSelector } from 'react-redux'
import { cardColor } from './styleFile'
import { ColoresInstitucionales } from './styleFile';
import { ufe_listarArchivos } from '../../function/axios';
import { useDispatch } from 'react-redux'
import { getArchiv } from '../../store/slices/archiv';
import { ufe_eliminarArchivo } from '../../function/axios';


const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: 'rgb(37,44,95)',
        color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));



const style = {
    width: '100%'
}









export default function File({ tipo, set, rut }) {

    let { id } = useParams()




    const dispatch = useDispatch()
    const { datosCae } = useSelector(state => state.datosCae)


    const { archiv } = useSelector(state => state.archiv)

    const [data, setData] = useState(archiv);
    const [load, setLoad] = useState(false);
    const [state, setState] = useState()//recibir archivos
    const { borrar, setBorrar } = useState({ id: id });
    const { estudiante } = useSelector(state => state.sesion)
    const [file, setFile] = useState([]);
    const [validateFiles, setValidateFiles] = useState(true);




    const cargarArchivos = (archivos) => {
        //console.log("kk", archivos)
        setFile([...file, ...archivos])
        set([...file, ...archivos])

    }


    // const archivosNombres = [
    //     `${rut}_solicitud_monto_ingreso`,
    //     `${rut}_historial_del_credito `,
    //     `${rut}_cedula_de_identidad`
    // ]


    const urlBase = 'https://ws.ugm.cl/storage/FAQ/Pregunta_'


    const eliminar = (borrar) => {

        //console.log('borrar', borrar)

        swal({
            title: "Estas seguro?",
            text: "Una vez eliminado, tedras que volver a agregarlo",
            icon: "warning",
            buttons: true,
            dangerMode: true,

        }).then((willDelete) => {


            if (willDelete) {

                const array = { rut_estudiante: datosCae.data[0].rut, tipo_proceso: 'CAE', ...borrar }

                ufe_eliminarArchivo(array)

                setLoad(true)


            } else {
                swal("Has cancelado con exito", {
                    timer: "1500"
                });
            }

        }).finally(() => {
            dispatch(getArchiv({ rut_estudiante: datosCae.data[0].rut, tipo_proceso: 'CAE' })).finally(() => {
                dispatch(getArchiv({ rut_estudiante: datosCae.data[0].rut, tipo_proceso: 'CAE' }))
                setLoad(false)
            });
        });

    }




    function buttonDelete(indexFile) {

        setFile(file.filter((value, index) => index != indexFile && value))
        set(file.filter((value, index) => index != indexFile && value))

    }


    function buttonDelete2(indexFile) {

        setData(data.filter((value, index) => index != indexFile && value))
        set(data.filter((value, index) => index != indexFile && value))

    }




    // const refresh = () => {


    //     const array = { codigo: id, tipo: 2, username: estudiante.sesion[0].correoInstitucional }

    //     obtenerArchivo(array).then((resp) => {

    //         setState(resp)


    //     }).catch((error) => {

    //         // //console.log('error', error)

    //     }).finally(() => {

    //         setLoad(false)

    //     })



    // }











    // const handleValidateFiles = () => {



    //     data.length == 2 ? setValidateFiles(true) : setValidateFiles(false)

    // }







    // useMemo(() => {

    //     handleValidateFiles()

    // }, [data.length]);












    const Visualizar = () => {




        return (
            <Grid sx={cardColor.backgroundStyleFile}> <p><b>Archivos Guardados</b></p>


                <TableContainer >

                    <Table aria-label="customized table">
                        <TableHead >
                            <TableRow>

                                <StyledTableCell>Archivos</StyledTableCell>
                                <StyledTableCell align="right">Acciones</StyledTableCell>
                            </TableRow>
                        </TableHead>



                    </Table>

                    <TableBody>
                        {archiv.map((value, index) => (




                            <StyledTableRow>
                                <StyledTableCell sx={style} component="th" scope="row">{value.NOMBRE_ARCHIVO}</StyledTableCell>
                                <StyledTableCell sx={style} align="right">
                                    <ButtonGroup>
                                        <Button variant="outlined" target={'_blank'} href={value.RUTA + value.NOMBRE_ARCHIVO} >
                                            <VisibilityIcon />
                                        </Button>
                                        {(datosCae.data[0].esre_cod == 0 || datosCae.data[0].esre_cod == 4) &&
                                        <Button onClick={() => eliminar({ nombre_archivo: value.NOMBRE_ARCHIVO, ruta_archivo: value.RUTA })} ><DeleteIcon /></Button>
                                        }
                                        </ButtonGroup>
                                </StyledTableCell>
                            </StyledTableRow>

                        ))}

                    </TableBody>
                </TableContainer>

            </Grid>




        )





    }







    const Cargar = (array) => {

        return array.length > 0 ?

            (

                <Grid sx={cardColor.backgroundStyleFile}> <p><b><Grid>Los archivos deben ser cargados en el siguiente orden:</Grid>
                    <Grid> Solicitud monto ingresa</Grid>
                    <Grid>  Historial del credito</Grid>
                    <Grid>  Cedula de identidad ambos lados</Grid></b></p>

                    <TableContainer >

                        <Table aria-label="customized table">
                            <TableHead>
                                <TableRow>
                                    <StyledTableCell>Archivos</StyledTableCell>
                                    <StyledTableCell align="right">Acciones</StyledTableCell>
                                </TableRow>
                            </TableHead>



                        </Table>

                        <TableBody>
                            {array.map((value, index) => (

                                <StyledTableRow>
                                
                                    <StyledTableCell sx={style} component="th" scope="row">{value.name}</StyledTableCell>
                                    {/* <StyledTableCell sx={style} component="th" scope="row">{archivosNombres[index]}</StyledTableCell> */}
                                    <StyledTableCell sx={style} align="right">
                                        <ButtonGroup>

                                            <Button variant="outlined" target={'_blank'} href={URL.createObjectURL(value)}>
                                                Visualizar
                                            </Button>
                                            {/* <Button variant="outlined" target={'_blank'} href={value.RUTA + value.NOMBRE_ARCHIVO} >
                                                <VisibilityIcon />
                                            </Button> */}
                                            <Button onClick={() => buttonDelete(index)} ><DeleteIcon /></Button>
                                        </ButtonGroup>
                                    </StyledTableCell>
                                </StyledTableRow>

                            ))}
                        </TableBody>
                    </TableContainer>
                </Grid>

            )

            :

            <></>

    }


    // renderSwitch(tipo) {

    //     switch (tipo) {
    //         case '1':

    //             return Cargar(file);

    //         case 2:

    //             return Visualizar();

    //         case 3:

    //             return Borrar();
    //     }


    // }

    if (load) {

        //carga
        return (<Load />)

    } else {


        return (
            <>
                {tipo == 1 &&
                    <Grid direction="row" alignItems="center" sx={cardColor.backgroundStyleSizeFile}>

                        <CardContent>
                            <Typography variant='h6'>
                                Debera cargar todos sus documentos aqui!!
                            </Typography>
                            <Typography variant='h6' color='red'>
                             El nombre del archivo no puede exceder los 30 caracteres.
                            </Typography>
                        </CardContent>


                        <Input
                            id="file"
                            sx={{ visibility: 'hidden' }}
                            name="file"
                            inputProps={{ multiple: true, accept: "application/pdf" }}
                            type="file"
                            onChange={e => cargarArchivos(e.target.files)}

                        />



                        <InputLabel htmlFor="file" sx={cardColor.backgroundStyleSizeFile} style={{ width: '50vw' }}>
                            <ButtonGroup fullWidth >
                                <Button variant="contained" sx={ColoresInstitucionales.azul} component="span" fullWidth  >
                                    <DriveFolderUploadIcon />Cargar Archivos
                                </Button>
                            </ButtonGroup>
                        </InputLabel >


                    </Grid>
                }

                <Card sx={cardColor.backgroundStyleSizeFile}>
                    <CardContent sx={{ marginY: -3 }} >
                        {/* {tipo == 1 ? Cargar(file) : Visualizar()} */}


                        {
                            (() => {
                                switch (tipo) {
                                    case 1:

                                        return Cargar(file);

                                    case 2:

                                        return Visualizar();


                                }
                            })()
                        }

                    </CardContent>
                </Card>



            </>
        );

    }





}
// {
//     file.map((value) => (
//         <p>{value.name}</p>
//     ))
// }
//
// onChange={e => {(e.target.files.length!=0) ? cargarArchivos(e.target.files) : cargarArchivos(file)}}



{/* <Button variant="outlined" target={'_blank'} href={URL.createObjectURL(value)}>
                                        Visualizar
                                    </Button> */}
